// Client-side photo prep and monthly collage drawing for Joy Snaps
export const prepPhoto = (file, maxSide = 1600) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const s = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
    const c = document.createElement("canvas");
    c.width = Math.round(img.naturalWidth * s); c.height = Math.round(img.naturalHeight * s);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(url);
    c.toBlob((b) => (b ? resolve(b) : reject(new Error("Couldn't read that photo"))), "image/jpeg", 0.88);
  };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Couldn't read that photo. Try a JPG or PNG.")); };
  img.src = url;
});

const loadImg = async (src) => {
  const blob = await (await fetch(src, { credentials: "include" })).blob();
  return createImageBitmap(blob);
};

const cover = (ctx, img, x, y, w, h) => {
  const s = Math.max(w / img.width, h / img.height);
  const sw = w / s, sh = h / s;
  ctx.drawImage(img, (img.width - sw) / 2, (img.height - sh) / 2, sw, sh, x, y, w, h);
};

const wrap = (ctx, text, x, y, maxW, lineH, maxLines = 2) => {
  const words = text.split(/\s+/); let line = "", n = 0;
  for (const w of words) {
    const t = line ? `${line} ${w}` : w;
    if (ctx.measureText(t).width > maxW && line) { ctx.fillText(line, x, y + n * lineH); line = w; if (++n >= maxLines) return; } else line = t;
  }
  if (line) ctx.fillText(n === maxLines - 1 && ctx.measureText(line).width > maxW ? `${line.slice(0, 20)}…` : line, x, y + n * lineH);
};

export const drawCollage = async ({ snaps, title, layout, captions, base }) => {
  const imgs = await Promise.all(snaps.map((s) => loadImg(`${base}${s.url}`)));
  const W = 1600, cols = snaps.length <= 4 ? 2 : snaps.length <= 9 ? 3 : 4, pad = 36, top = 170;
  const cell = (W - pad * (cols + 1)) / cols, capH = captions ? 70 : 0, rows = Math.ceil(snaps.length / cols);
  const H = top + rows * (cell + capH + pad) + pad + 30;
  const c = document.createElement("canvas"); c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  ctx.fillStyle = layout === "polaroid" ? "#EFE6D8" : "#F6F1FB"; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "#5B3F8F"; ctx.font = "bold 72px Georgia, serif"; ctx.textAlign = "center"; ctx.fillText(title, W / 2, 112);
  imgs.forEach((img, i) => {
    const x = pad + (i % cols) * (cell + pad), y = top + Math.floor(i / cols) * (cell + capH + pad);
    ctx.save();
    if (layout === "polaroid") {
      ctx.translate(x + cell / 2, y + (cell + capH) / 2); ctx.rotate((((i * 47) % 9) - 4) * Math.PI / 180); ctx.translate(-(x + cell / 2), -(y + (cell + capH) / 2));
      ctx.shadowColor = "rgba(0,0,0,.18)"; ctx.shadowBlur = 18; ctx.fillStyle = "#fff";
      ctx.fillRect(x - 14, y - 14, cell + 28, cell + capH + (captions ? 14 : 48)); ctx.shadowBlur = 0;
      cover(ctx, img, x, y, cell, cell);
    } else {
      ctx.beginPath(); ctx.roundRect(x, y, cell, cell, 28); ctx.clip(); cover(ctx, img, x, y, cell, cell);
    }
    ctx.restore();
    if (captions && snaps[i].caption) {
      ctx.fillStyle = "#3A2E4F"; ctx.font = "30px Georgia, serif"; ctx.textAlign = "center";
      wrap(ctx, snaps[i].caption, x + cell / 2, y + cell + 42, cell - 20, 34);
    }
  });
  return new Promise((r) => c.toBlob(r, "image/png"));
};
